import BlockErrorsChip from './BlockErrorsChip/BlockErrorsChip'
import BlockVisibilityBadges from './BlockVisibilityBadges/BlockVisibilityBadges'
import * as Styles from './styles'

const BlockPreview = ({ blockId, content, visibility, timeZone, errorCount }) => {
  return (
    <Styles.Container data-block-id={blockId}>
      <Styles.Content inert>{content}</Styles.Content>
      <Styles.Badges>
        {visibility && <BlockVisibilityBadges visibility={visibility} timeZone={timeZone} />}
        {errorCount > 0 && <BlockErrorsChip count={errorCount} />}
      </Styles.Badges>
    </Styles.Container>
  )
}

export default BlockPreview
